import { ListingRoundedImage } from "../../listingRoundedImage";
import { useListingReviewCardContext } from "./ListingReviewCardProvider";
import useImageSize from "../../../../../hooks/global/useImageSize";

export const ListingReviewCardProfileImage = () => {
  const { state } = useListingReviewCardContext();
  const [resizedProfileImage] = useImageSize({
    isProfile: true,
    originalFormat: true,
    imageUrl: state.review.user.avatarUrl,
    size: 300,
  });
  return (
    <ListingRoundedImage
      useBorder={false}
      className="w-[40px] h-[40px]"
      title={state.review.user.name}
      image={resizedProfileImage}
    />
  );
};
